import React, { Fragment, lazy } from 'react';
import DeferredSection from '../../components/DeferredSection';
// import Navbar from '../../components/Navbar' // Old navbar commented out
import TransparentNavbar from '../../components/TransparentNavbar' // New transparent navbar
import Hero2 from '../../components/hero2';
import About2 from '../../components/about2';
import ProjectSectionS2 from '../../components/ProjectsS2';
import ServiceSection from '../../components/Services';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.svg'
import DeliveredProjectsSection from '../../components/DeliveredProjectsSection';
import CompanySection from '../../components/CompanySection';
import Seo from '../../components/Seo';
import HeroContactForm from '../../components/HeroContactForm';
import GoldcrestBanner from '../../components/GoldcrestBanner';


// The carousel library is only needed this far down the page, so it is split out of the main bundle.
const VideoTestimonials = lazy(() => import('../../components/VideoTestimonials'));

// Served from /public and preloaded in index.html so they are ready when the hero first renders.
const certificates = [1, 2, 3].map((n) => ({
    src: `${process.env.PUBLIC_URL}/images/certificates/certificate-${n}.png`,
    alt: `Giga Group certificate ${n}`,
}));

const HomePage2 = () => {

    return (
        <Fragment>
            <Seo
                title="Giga Group - Leading Real Estate Developer in Pakistan, Islamabad - High Rise Community in Pakistan - Giga City Islamabad"
                description="Giga Group is a leading real estate developer in Pakistan, DHA Phase 2 Islamabad. Offering a variety of residential and commercial projects with 70+ years of excellence."
                keywords="Real Estate Developer"
            />
            {/* <Navbar Logo={Logo}/> */} {/* Old navbar commented out */}
            <TransparentNavbar Logo={Logo} /> {/* New transparent navbar */}
            <GoldcrestBanner />
            <Hero2 priority>
                <div className="slide-content">
                    <div className="c-wrapper c-wrapper--home">
                        <div className="hero-home-copy">
                            <h1 className="l7-text">GIGA GROUP</h1>
                            <p className='l2-text'>DELIVERING EXCELLENCE SINCE 1956</p>
                            <p className="l8-text">Vision, Giga Group</p>
                        </div>
                        <HeroContactForm />
                        <div className="hero2-certificates">
                            {certificates.map((certificate) => (
                                <div className="hero2-certificate-item" key={certificate.src}>
                                    <img src={certificate.src} alt={certificate.alt} />
                                </div>
                            ))}
                        </div>
                        {/* <div>
                            <p className='l5-text'>FROM LUXURY RESIDENCES TO WORLD-CLASS COMMERCIAL SPACES. 70 YEARS OF DELIVERING ICONIC DEVELOPMENTS ACROSS PAKISTAN AND THE UAE</p>
                        </div> */}
                    </div>
                    {/* <div className="clearfix"></div> */}
                    {/* <div className="slide-btns">
                        <Link to='/about-us' className="theme-btn">Discover More</Link>
                    </div> */}
                </div>
            </Hero2>
            <Hero2
                videoUrl='https://www.youtube.com/embed/uI24t0e6sVU?autoplay=1&mute=1&loop=1&playlist=uI24t0e6sVU&controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3'
                mobileVideoUrl='https://www.youtube.com/embed/uI24t0e6sVU?autoplay=1&mute=1&loop=1&playlist=uI24t0e6sVU&controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3'
                poster={`${process.env.PUBLIC_URL}/images/hero/uI24t0e6sVU-desktop.webp`}
                mobilePoster={`${process.env.PUBLIC_URL}/images/hero/uI24t0e6sVU-mobile.webp`}
            >
                <div className="slide-content">
                    <div className={`c-wrapper`}>
                        <div>
                            <h2 className="l7-text"> <p className='l6-text'>GigaCity</p> Islamabad</h2>
                            <p className='l2-text'>Pakistan's no. 1 vertical community in DHA-II Islamabad</p>
                        </div>
                        <div>
                            <p className='l2-text'>Developed by Giga Group</p>
                            {/* <p className="l4-text">Vision, Giga Group</p> */}
                        </div>
                        {/* <div>
                            <p className='l2-text'>Developed by Giga Group</p>
                        </div> */}
                    </div>
                    {/* <div className="clearfix"></div> */}
                    {/* <div className="slide-btns">
                        <Link to='/about-us' className="theme-btn">Discover More</Link>
                    </div> */}
                </div>
            </Hero2>
            {/* uI24t0e6sVU */}
            <Hero2
                videoUrl="https://www.youtube.com/embed/OtcV-pML4Zo?autoplay=1&mute=1&loop=1&playlist=OtcV-pML4Zo&controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3"
                mobileVideoUrl="https://www.youtube.com/embed/ws2mz5p3X8I?autoplay=1&mute=1&loop=1&playlist=ws2mz5p3X8I&controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3"
                poster={`${process.env.PUBLIC_URL}/images/hero/OtcV-pML4Zo-desktop.webp`}
                mobilePoster={`${process.env.PUBLIC_URL}/images/hero/ws2mz5p3X8I-mobile.webp`}
            >
                <div className="slide-content">
                    <div className={`c-wrapper-2`}>
                        <div>
                            <h2 className="l9-text">Goldcrest Views</h2>
                            {/* <p className='l2-text'>Giga City Islamabad</p> */}
                        </div>
                        <div>
                            {/* <p className='l3-text'>Developed by Giga Group</p> */}
                            <p className="l8-text">Giga City Islamabad</p>
                        </div>
                        <div>
                            {/* <p className="l4-text">Giga City Islamabad</p> */}

                            {/* <p className='l5-text'>FROM LUXURY RESIDENCES TO WORLD-CLASS COMMERCIAL SPACES. 70 YEARS OF DELIVERING ICONIC DEVELOPMENTS ACROSS PAKISTAN AND THE UAE</p> */}
                        </div>
                    </div>
                    {/* <div className="clearfix"></div> */}
                    {/* <div className="slide-btns">
                        <Link to='/about-us' className="theme-btn">Discover More</Link>
                    </div> */}
                </div>
            </Hero2>
            <About2 />
            <ServiceSection sClass={'section-bg'} />
            <ProjectSectionS2 />
            {/* <TeamSection/> */}
            {/* <BlogSection/> */}
            <DeliveredProjectsSection />
            <CompanySection />
            <DeferredSection>
                <VideoTestimonials />
            </DeferredSection>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage2;